import { PropsWithChildren, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuth } from './AuthProvider';

type ProtectedRouteProps = PropsWithChildren<object>;

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const user = useAuth();
  const navigate = useNavigate();
  const [authenticated, setAuthenticated] = useState<boolean | null>(null);

  useEffect(() => {
    if (user === null) {
      navigate('/login', { replace: true });
    } else {
      setAuthenticated(true);
    }
  }, [navigate, user]);

  // Return null if user is not authenticated to prevent rendering of unauthorized content
  return authenticated ? <>{children}</> : null;
}
